<!--For Notification Highliter-->
<div class="row">
  <div *ngIf="status===1 " class="text-lg-center">
    <ngb-alert [dismissible]="false" [type]="'success'"><i class="feather icon-thumbs-up"></i>{{"Kyc is approved" |
      uppercase}}</ngb-alert>
  </div>
  <div *ngIf="status===2 " class="text-lg-center">
    <ngb-alert [dismissible]="false" [type]="'danger'"><i class="feather icon-thumbs-down"></i> {{"Kyc is rejected" |
      uppercase}}</ngb-alert>
  </div>
</div>

<div class="card">

  <!-- ICP Document Verification Link Start-->
    <div>
      <hr>
      <h3 class="text-center">ICP ID Verification Link</h3>
    </div>
    <div class="row d-flex p-2">
      <div class="mb-2 text-center">
       <button type="button" class="btn btn-primary" ngbTooltip="You can search by EID, passport number, file number" (click)="icpLink(1)">Link 1</button>
       <button type="button" class="btn btn-primary" ngbTooltip="Less user-friendly, less capabilities, but shows the name of the holder as well" (click)="icpLink(2)">Link 2</button>
    </div>
    <!-- ICP Document Verification Link End-->

  <!-- file upload section-->
  <div class="row">
    <div class="card-body row">
      <form [formGroup]="allKycDataFormGroup" *ngIf="merchantKycDetails?.length > 0 && this.allKycDataFormGroup">
        <div class="row mb-4 form-check">
          <div class="col-2">
            <input class="form-check-input" formControlName="isWavier" id="isWavier" type="checkbox"
                   (change)="onChangeWavier($event)"/>

          </div>
          <div class="col-10">
            <label class="form-check-label card-title" style="color: red">Allow waiver/exception</label>
          </div>
          <span *ngIf="isKycFormSubmitted && allKycDataFormGroup.errors?.waiverError" #waverError id="waverError"
               class="text-danger">
            Need to Upload all the docs
          </span>
        </div>
<!--                {{ wavierRemarks?.errors | json}}-->
<!--                {{ wavierOffDate?.errors | json}}-->

        <div class="row" *ngIf="isWavier?.value">
          <div class="col-sm-6">
            <label class="col-form-label" for="wavierRemarks">Wavier Remarks<span aria-hidden="true"
                                                                                  class="symbol required"
                                                                                  style="color:red;">*</span></label>
            <div class="col-sm-9">
              <input [ngClass]="{'is-invalid': isKycFormSubmitted && wavierRemarks?.errors}"
                     class="form-control"
                     formControlName="wavierRemarks" id="wavierRemarks" placeholder="Wavier Remarks" type="text"
                     maxlength="100" pattern="[a-zA-Z][a-zA-Z ]+"
                     [disabled]="(!(permissions.includes('Add')))"
              >
              <div *ngIf="isKycFormSubmitted && wavierRemarks?.errors?.required"
                   class="invalid-feedback">
                Wavier Remarks is required
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <label class="col-form-label" for="wavierOffDate">Timebound<span aria-hidden="true" class="symbol required"
                                                                             style="color:red;">*</span></label>
            <div class="col-sm-9">
              <input type="date" class="form-control" min="{{currentDate|date:'yyyy-MM-dd'}}" placeholder="dd-mm-yyyy"
                     formControlName="wavierOffDate" id="wavierOffDate" onkeydown="return false"
                     [ngClass]="{'is-invalid': isKycFormSubmitted && allKycDataFormGroup.get('wavierOffDate')?.errors}"
                     [disabled]="(!(permissions.includes('Add')))"
              >
              <div *ngIf="isKycFormSubmitted && allKycDataFormGroup.get('wavierOffDate')?.errors?.required"
                   class="invalid-feedback">
                Timebound is required
              </div>
            </div>
          </div>
        </div>
        <div class="kyc-upload mt-4" formArrayName="merchantKycData">
          <div class="row mb-2" *ngFor="let u of merchantKycDataArr();let i= index" [formGroupName]="i">
<!--            {{this.isKycFormSubmitted}}-->
            <div class="row">
<!--              {{ this.getDocListError(i)?.errors | json}}-->
              <div class="col-sm-7 align-middle">
                <h5 class="card-title">{{i + 1}}. {{u.value?.document}}<span *ngIf="u.value.mandatory === 'Y'" aria-hidden="true" class="symbol required" style="color:red;">*</span>
                </h5>
                <span class="text-muted" *ngIf="u.value?.subtext">({{u.value?.subtext}})</span>
              </div>
              <div class="col-sm-1" style="color: rgb(36, 196, 36);">
                <div [style.display]=" u.value?.type==='single' && u.value?.uploadSuccess  ? 'block' : 'none'">
                  <i class="feather icon-check-circle icon-lg"></i>
                </div>
              </div>
              <div class="col-sm-2 row mb-2">
                <div class="col-md-12">
                  <div class="input-group" *ngIf="u.value?.type==='single'">
                    <label class="input-group-btn">
                      <!-- [disabled]="isButtonDisable(i) || globalDisableFlag" -->
                      <button class="btn" (click)="kycUploadFormSelect(u.value?.type, merchantKycDataArr()[i], i )"
                              ngbTooltip="Click to Open File Uploader"
                              [disabled]="isButtonDisable(i) || globalDisableFlag"
                              [ngClass]="isKycFormSubmitted && u.get('docName')?.errors?.required ? 'btn-outline-danger' : 'btn-primary' ">
                        Browse<input #takeInput [attr.id]="i" class="form-control form-control-sm"
                                        [style.color]="true ? 'limegreen' : ''"
                                        (change)="onFileSelect($event,i,u.value?.docId,u.value?.kycId)"
                                        type="file" style="display: none;" multiple>
                      </button>
                      <!-- [disabled]="isButtonDisable(i) || globalDisableFlag" -->

                    </label>
                  </div>
                  <!-- <div class="align-vertical" *ngIf="u.value?.type==='other'">
                    <div class="btn btn-warning text-uppercase" style="border-radius: 15px"
                         [ngClass]="{ 'disabled': globalDisableFlag}"
                         ngbTooltip="Click to add custom document type"
                         (click)="!globalDisableFlag && addCustomDocType(i, u)"><i class="feather icon-plus"></i> Add
                    </div>
                  </div> -->

                </div>
              </div>
              <div class="col-sm-2">
                <!--                {{ u.get('docList').controls[0]?.get('docPath').value}}-->
                <div class="row mt-2">
                  <div class="col-4">
                    <span *ngIf="u.value?.type==='single'" ngbTooltip="Uploaded Document Count"
                          class="badge bg-warning">{{u.get('docList').controls[0]?.get('docPath').value !== '' ? getDocCount(u) : 0}}</span>
                  </div>
                  <div class="col-4" *ngIf="!callCenterView">
                    <a *ngIf="u.value?.type==='single'" href="javascript:void(0)"
                       (click)="kycUploadFormSelect(u.value?.type, merchantKycDataArr()[i], i, undefined, 'view' )"
                       ngbTooltip="View Document">
                      <i class="feather icon-inbox icon-lg"></i>
                    </a>
                    <!--                    <a *ngIf="u.value?.type==='single'" href="javascript:void(0)"-->
                    <!--                      (click)="addCustomDocList(i, u)" tooltip="List Uploaded Documents">-->
                    <!--                      <i class="feather icon-eye icon-lg"></i>-->
                    <!--                    </a>-->
                  </div>
                  <div class="col-4">
                  
                    <a *ngIf="!globalDisableFlag && u.value?.type==='single' && merchantKycDataArr()[i].get('docTypeList')['controls'].length >= 0" href="javascript:void(0)"
                       (click)="resetSelection($event, i, u)" ngbTooltip="Delete Document">
                      <i class="feather icon-refresh-cw icon-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
                        <!-- Display error message for missing mandatory documents -->
       <!-- Simplified check for testing -->
<div class="row" style="margin-top: -3%;" *ngIf="isKycFormSubmitted && u.value?.mandatory === 'Y' && !u.value?.docList[0].docPath.length">
  <div class="col-sm-12">
    <span class="text-danger">This document is mandatory. Please upload the file.</span>
  </div>
</div>

<!-- <div *ngIf="isKycFormSubmitted">
  <p>Mandatory: {{ u.value?.mandatory }}</p>
  <p>Doc List Length: {{ u.value?.docList[0].docPath }}</p>
</div> -->
            <div class="row">
              <div formArrayName="docTypeList">
                <!--                <div class="row mb-2" *ngFor="let docU of merchantKycDataArr()[i].get('docTypeList')['controls'];let j= index" [formGroupName]="j">-->
                <!--                  <input type="text" formControlName="isSelected">-->
                <!--                </div>-->
                <!-- <div class="row"
                     *ngFor="let radio of merchantKycDataArr()[i].get('docTypeList')['controls'];let rad =index;"
                     [formGroupName]="rad">
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-check form-check-inline form-control">
                        <input *ngIf="u.value?.type==='single'" formControlName="isSelected"
                               (change)='onRadioSelect($event,i,rad,radio)' [attr.name]="i"
                               type="radio" class="form-check-input" [value]="radio.value?.docType"/>
                        <input *ngIf="(u.value?.type==='multi' || u.value?.type==='other')" formControlName="isSelected"
                               [checked]="!!radio.value?.docPath"
                               (change)="onDocTypeChangeSingle(i, rad)"
                               type="checkbox" class="form-check-input" [value]="radio.value?.docType" [attr.name]="i">

                        <label *ngIf="u.value?.type==='single' || u.value?.type==='multi'" class="form-check-label">
                          {{radio.get('docType').value | titlecase}}
                        </label>

                        <input *ngIf="u.value?.type==='other' && radio.value?.inputDisabled" type="text"
                               formControlName="docType" class="form-control"
                               [disabled]="radio.value?.inputDisabled"
                               style="border: 1px solid #697DD1 !important;" [attr.disabled]="true"/>
                        <input *ngIf="u.value?.type==='other' && !radio.value?.inputDisabled" type="text"
                               formControlName="docType" class="form-control"
                               [disabled]="radio.value?.inputDisabled"
                               [ngClass]="{'is-invalid': radio?.get('docType').errors || (isKycFormSubmitted && getDocTypeListError(i, rad))}"
                               />
                      </div>

                    </div>
                    <div class="col-sm-1 mt-2" style="color: rgb(36, 196, 36);">
                      <div *ngIf="!globalDisableFlag && (u.value?.type==='multi' || u.value?.type==='other') && !radio.value?.inputDisabled">
                        <a href="javascript:void(0)" class="text-danger" (click)="removeCustomDocType(i, rad)">
                          <i class="feather icon-minus-circle icon-lg"></i>
                        </a>
                      </div>
                    </div>

                    <div class="col-md-2" *ngIf="u.value?.type==='multi' || u.value?.type==='other'">
                      <div class="form-control">
                        <button class="btn" [id]="i+'-'+rad"
                                ngbTooltip="Click to Open File Uploader"
                                [disabled]="isButtonDisable(i, rad) || globalDisableFlag"
                                (click)="kycUploadFormSelect(u.value?.type, merchantKycDataArr()[i], i, rad )"
                                [ngClass]="isKycFormSubmitted && getSubDocError(i, rad, u.docid, radio) ? 'btn-outline-danger' : 'btn-primary' "
                        >Browse
                          <input #takeInputSub [attr.id]="i+'sub'" class="form-control form-control-sm"
                                 [style.color]="'limegreen'"
                                 (change)="onFileSelectMulti($event,i,radio.value?.docId,radio.value?.kycId, radio.value?.type, rad)"
                                 [disabled]="isButtonDisable(i, rad) || globalDisableFlag"
                                 type="file" style="display: none;" multiple>
                        </button>
                      </div>
                    </div>
                    <div class="col-sm-2 mt-2" *ngIf="u.value?.type==='multi' || u.value?.type==='other'">
                      <div class="row mt-2">
                        <div class="col-4">
                        <span ngbTooltip="Uploaded Document Count"
                          class="badge bg-warning">{{radio.get('docList').controls[0]?.get('docPath').value !== '' ? radio.get('docList').controls?.length || 0 : 0}}</span>
                        </div>
                        <div class="col-4">
                          <a *ngIf="u.value?.type==='multi' || u.value?.type==='other'" href="javascript:void(0)"
                             (click)="kycUploadFormSelect(u.value?.type, merchantKycDataArr()[i], i, rad, 'view')"
                             ngbTooltip="More">
                            <i class="feather icon-inbox icon-lg"></i>
                          </a>
                        </div>
                        <div class="col-4">
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="row" *ngIf="u.value?.type==='multi' || u.value?.type==='other'">
                    <span *ngIf="isKycFormSubmitted && getDocTypeListError(i, rad) && radio.get('docList')?.value?.length ===0" class="text-danger"
                         [style]="isKycFormSubmitted && getDocTypeListError(i, rad) ? 'display:block': 'display: none'">
                      Please upload minimum one file
                    </span>
                    <span *ngIf="isKycFormSubmitted && getDocTypeListError(i, rad) && radio.get('docType')?.value ===''" class="text-danger"
                         [style]="isKycFormSubmitted && getDocTypeListError(i, rad) ? 'display:block': 'display: none'">
                      Please Enter Doc Type
                    </span>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- <div class="row" *ngIf="isKycFormSubmitted && this.getDocListError(i)?.errors && (u.value?.type==='single')">
                <span *ngIf="isKycFormSubmitted && this.getDocListError(i)?.errors?.required" class="text-danger">
                  Please select proper doc type and upload file
                </span>
            </div>
            <div class="row" *ngIf="isKycFormSubmitted && this.getDocListError(i)?.errors && (u.value?.type==='multi' || u.value?.type==='other')">
                <span *ngIf="isKycFormSubmitted && this.getDocListError(i)?.errors?.required && !this.isWavier?.value" class="text-danger">
                  Please select at least one doc type and upload file
                </span>
            </div> -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <div class="mb-3 col-md-12" *ngIf="merchantKycDetails?.length > 0 && permissions.includes('Add')"
                 style="margin-top:auto ;margin-bottom: auto;text-align: right;">
              <button class="form-control btn btn-primary" (click)="submitKycData($event, allKycDataFormGroup.value)"
                      type="submit"
                      value="Submit">Submit
              </button>
            </div>
          </div>
        </div>

      </form>
      <div *ngIf="merchantKycDetails?.length ===0" class="card-title"><h4>No KYC Data available</h4></div>
    </div>


    <!-- -----------------------------UBO START------------------------------- -->
    
    <div>
      <hr>
      <h3 class="text-center">Shareholders/Partners/UBO/POA<span aria-hidden="true" class="symbol required" style="color:red;">*</span></h3>
    </div>
    <div class="mt-2" *ngFor="let form of forms; let i = index">
      <form  [formGroup]="formGroup" (ngSubmit)="submitForms(i)" >
        <fieldset [formGroup]="form" class="form-group">
      <ngb-accordion>
        <ngb-panel>
          <ng-template ngbPanelTitle>
            <h5>{{form.value.typeOfShareHolder}} - ({{form.value.shareHolderName?form.value.shareHolderName:"New"}})</h5>
          </ng-template>
          <ng-template ngbPanelContent>
            <div *ngIf="form.value.typeOfShareHolder === 'Individual'">
              <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="roleInEntity">Role in Entity<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <ng-select formControlName="roleInEntity" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Role in Entity" type="text" 
                      [items]="roleInEntityDropdown">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('roleInEntity')?.invalid && form.get('roleInEntity')?.touched" class="error">
                      Please Select Role in Entity
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="shareHolderOf">Shareholder Of</label>  
                      <input formControlName="shareHolderOf" [readonly]="true" type="text" class="form-control" />                      
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="shareHolderName">Shareholder Name<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <input formControlName="shareHolderName" [readonly]="!showFinalButton" type="text" class="form-control" placeholder="Enter Share Holder Name"/>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderName')?.invalid && form.get('shareHolderName')?.touched" class="error">
                      Please Enter Share Holder Name
                    </div>                       
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="shareHolderPercentage">Shareholder % <span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="shareHolderPercentage" maxlength="5" [readonly]="!showFinalButton" type="text" class="form-control" placeholder="Enter Shareholder Percentage"  onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)"/>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderPercentage')?.errors?.required && form.get('shareHolderPercentage')?.touched" class="error"> 
                      Please Enter Shareholder Percentage
                    </div>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderPercentage')?.errors?.max && form.get('shareHolderPercentage')?.touched" class="error">
                      Shareholder Percentage must be below or equal to 100
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="nationality">Nationality<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <!-- <input formControlName="nationality" type="text" class="form-control" placeholder="Select Nationality"/> -->
                      <ng-select formControlName="nationality" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Nationality" type="text" 
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('nationality')?.invalid && form.get('nationality')?.touched" class="error">
                      Please Select Nationality
                    </div>                       
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="dateOfBirth">Date of Birth<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <!-- <input formControlName="dateOfBirth" type="text" class="form-control" placeholder="Select Date of Birth"/> -->
                    <input formControlName="dateOfBirth" ngbDatepicker [readonly]="!showFinalButton"  #dob="ngbDatepicker"  (click)="dob.toggle()"class="form-control" placeholder="Select Date of Birth"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"  [maxDate]="maxDateFromDob" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                    <div style="color:#ff3366" *ngIf="form.get('dateOfBirth')?.invalid && form.get('dateOfBirth')?.touched" class="error">
                      Please Select Date of Birth
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="placeOfBirth">Place of Birth<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label> 
                      <ng-select formControlName="placeOfBirth" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Place of Birth" type="text" 
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('placeOfBirth')?.invalid && form.get('placeOfBirth')?.touched" class="error">
                      Please Select Place of Birth
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="address">Residential Address</label>  
                      <input formControlName="address" type="text" [readonly]="!showFinalButton" class="form-control" maxlength="400" placeholder="Enter Residential Address"/>                    
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="dualNationality">Dual Nationality</label>  
                      <!-- <input formControlName="dualNationality" type="text" class="form-control" placeholder="Select Dual Nationality"/>   -->
                      <ng-select formControlName="dualNationality" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" type="text" (change)="disabledDropdown($event,i)" placeholder="Select Dual Nationality">
                        <ng-option value="YES">Yes</ng-option>
                        <ng-option value="NO">No</ng-option>
                      </ng-select>                   
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="secondNationality">Nationality (Second)</label>  
                    <!-- <input formControlName="secondNationality" type="text" class="form-control" placeholder="Select Nationality (Second)"/> -->
                    <ng-select [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : form.value.nationalityColor" [readonly]="!showFinalButton" formControlName="secondNationality" placeholder="Select Nationality (Second)" type="text" 
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                    </ng-select>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="countryOfResidence">Residential Country<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label> 
                      <ng-select formControlName="countryOfResidence" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" (change)="changeResidenceCountry($event,i)" [readonly]="!showFinalButton" placeholder="Select Country of Residence" type="text" 
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('countryOfResidence')?.invalid && form.get('countryOfResidence')?.touched" class="error">
                      Please Select Residential Country
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="eid">Emirates ID Number</label>  
                      <input formControlName="eid" type="text" appEmiratesIdFormatter [readonly]="!showFinalButton" class="form-control" placeholder="Enter Emirates ID Number (XXX-XXXX-XXXXXXX-X)" maxlength="18"/>
                    <div style="color:#ff3366" *ngIf="form.get('eid')?.errors?.required && form.get('eid')?.touched" class="error">
                      Please Enter Emirates ID Number
                    </div> 
                    <div style="color:#ff3366" *ngIf="form.get('eid')?.errors?.pattern && form.get('eid')?.touched" class="error">
                      Please Enter Valid Emirates ID Number
                    </div> 
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="eidIssueDate">Emirates Issue Date</label>  
                      <input formControlName="eidIssueDate" ngbDatepicker [readonly]="!showFinalButton" #d="ngbDatepicker" class="form-control" placeholder="Select Emirates Issue Date"
                        [minDate]="{ year: 1900, month: 1, day: 1 }"[maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate($event,i)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                    <div style="color:#ff3366;" *ngIf="form.get('eidIssueDate')?.errors?.required && form.get('eidIssueDate')?.touched" class="error">
                      Please Select Emirates Issue Date
                    </div>                       
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="eidExpiryDate">Emirates Expiry Date</label>  
                    <input formControlName="eidExpiryDate" class="form-control" [readonly]="!showFinalButton" ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="Select Emirates Expiry Date"
                         [minDate]="minDate"  [maxDate]="maxDateFromHundred" (ngModelChange)="changeEndDate($event)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()" />
                    <div style="color:#ff3366;" *ngIf="form.get('eidExpiryDate')?.errors?.required && form.get('eidExpiryDate')?.touched" class="error">
                      Please Select Emirates Expiry Date
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="passportIssueCountry">Passport Issue Country<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <ng-select [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" formControlName="passportIssueCountry" placeholder="Select Passport Issue Country"
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                    </ng-select>
                    <div style="color:#ff3366;" *ngIf="form.get('passportIssueCountry')?.invalid && form.get('passportIssueCountry')?.touched" class="error">
                     Please Select Passport Issue Country
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="passportNumber">Passport Number<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <input formControlName="passportNumber" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter passport Number"/>
                    <div style="color:#ff3366" *ngIf="form.get('passportNumber')?.errors?.required && form.get('passportNumber')?.touched" class="error">
                      Please Enter Passport Number
                    </div> 
                    <div style="color:#ff3366" *ngIf="form.get('passportNumber')?.errors?.pattern && form.get('passportNumber')?.touched" class="error">
                      Please Enter Valid Passport Number
                    </div> 
                    <!-- <div style="color:#ff3366" *ngIf="form.get('idNumber')?.errors?.['pattern']  && form.get('idNumber')?.touched" class="error">
                      {{ getPatternErrorMessage(i) }}
                    </div>                                        -->
                  </div>
                  
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="passportIssueDate">Passport Issue Date<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <input formControlName="passportIssueDate" ngbDatepicker [readonly]="!showFinalButton" #p="ngbDatepicker" class="form-control" placeholder="Select Passport Issue Date"
                        [minDate]="{ year: 1900, month: 1, day: 1 }"[maxDate]="maxDateFromPassport" (click)="p.toggle()" (ngModelChange)="changeDatePassportIssue($event,i)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                    <div style="color:#ff3366;" *ngIf="form.get('passportIssueDate')?.invalid && form.get('passportIssueDate')?.touched" class="error">
                      Please Select Passport Issue Date
                    </div>                       
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="passportExpiryDate">Passport Expiry Date<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <!-- <input formControlName="idExpiryDate" type="text" class="form-control" placeholder="Enter Shareholder Percentage"/> -->
                    <input formControlName="passportExpiryDate" class="form-control" [readonly]="!showFinalButton" ngbDatepicker #p1="ngbDatepicker"  (click)="p1.toggle()" placeholder="Select Passport Expiry Date"
                         [minDate]="minDatePassport"  [maxDate]="maxDateFromHundred" (ngModelChange)="changeDatePassportExpiry($event)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()" />
                    <div style="color:#ff3366;" *ngIf="form.get('passportExpiryDate')?.invalid && form.get('passportExpiryDate')?.touched" class="error">
                      Please Select Passport Expiry Date
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="mobileNumber">Mobile Number<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="mobileNumber" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter Mobile Number" maxlength="15" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode  <= 57) || event.key === '+'"/>
                    <div style="color:#ff3366;" *ngIf="form.get('mobileNumber')?.errors?.required && form.get('mobileNumber')?.touched" class="error">
                      Please Enter Mobile Number
                    </div>
                    <div style="color:#ff3366;" *ngIf="form.get('mobileNumber')?.errors?.pattern && form.get('mobileNumber')?.touched" class="error">
                      Please Enter Valid Mobile Number
                    </div>
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="emailId">Email ID<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="emailId" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter Email ID"/>
                    <div style="color:#ff3366" *ngIf="form.get('emailId')?.errors?.required && form.get('emailId')?.touched" class="error">
                      Please Enter Email ID
                    </div> 
                    <div style="color:#ff3366;" *ngIf="form.get('emailId')?.errors?.pattern && form.get('emailId')?.touched" class="error">
                      Please Enter Valid Email ID
                    </div>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="pepFlag">PEP Flag</label>  
                      <!-- <input formControlName="pepFlag" type="text" class="form-control" placeholder="Enter PEP Flag"/>   -->
                      <ng-select formControlName="pepFlag" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" type="text" [readonly]="!showFinalButton" (change)="disabledPepDropdown($event,i)" placeholder="Enter PEP Flag">
                        <ng-option value="YES">Yes</ng-option>
                        <ng-option value="NO">No</ng-option>
                      </ng-select>                   
                  </div> 
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="pepCategory">PEP Category</label>  
                    <input formControlName="pepCategory" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter PEP Category"/>
                  </div>
                </div>
                <div class="row d-flex upload-wrapper">
                  <div class="form-group col-md-12">
                      <label class="col-form-label" for="document">ID Upload<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                        <div class="file-preview" *ngFor="let document of form.value.documentList;">
                          <P>{{document.name}}</P>
                          <div class="file-actions">
                            <a (click)="downloadDocument(document.url,document.name)"><i class="feather icon-download icon-lg"></i></a>
                            <a *ngIf="permissions.includes('Approve')" (click)="deletedDocument(form.value.id,document.url)"><i class="feather icon-x icon-lg"></i></a>
                          </div>
                        </div>
                        <div class="file-preview" *ngIf="form.value.newFileName">
                          <!-- <P>New Document : </P> -->
                          <input type="text" [value]="form.value.newFileName" [title]="form.value.newFileName" disabled />
                          <div class="file-actions">
                            <a (click)="removeFile(i)"><i class="feather icon-x-circle icon-lg"></i></a>
                          </div>
                        </div>
                      <div class="upload-dropzone" (click)="fileInput.click()" *ngIf="permissions.includes('Add') && showFinalButton" (drop)="handleDrop($event,i)" (dragover)="allowDrop($event)">
                        Click or Drag Here to Upload
                        <input #fileInput type="file" multiple accept=".pdf,image/*" hidden (change)="onFileChange($event,i)" />
                      </div>
                    <div style="color:#ff3366;" *ngIf="form.get('document')?.hasError('required')" class="error">
                      Please Upload Document
                    </div>                       
                  </div>
                </div>
                <div class="text-right">
                    <div class="form-group col-md-12">
                        <button *ngIf="permissions.includes('Add')" type="submit" class="btn btn-primary">Save</button>
                        <button *ngIf="!form.value.id && permissions.includes('Add')" (click)="removeForm(i)" type="button" class="btn btn-danger">Remove</button>
                        <button *ngIf="form.value.id && !showFinalButton && permissions.includes('Approve')" (click)="deleteOwner(form.value.id)" type="button" class="btn btn-danger">Delete</button>
                    </div>
                </div>
            </div>
            <div *ngIf="form.value.typeOfShareHolder === 'POA'">
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="roleInEntity">Role in Entity</label>  
                    <input formControlName="roleInEntity" [readonly]="true" type="text" class="form-control" />                      
                </div>
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="shareHolderName">POA Name<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="shareHolderName" [readonly]="!showFinalButton" type="text" class="form-control" placeholder="Enter POA Name"/>
                  <div style="color:#ff3366" *ngIf="form.get('shareHolderName')?.invalid && form.get('shareHolderName')?.touched" class="error">
                    Please Enter POA Name
                  </div>                       
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="nationality">Nationality<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <!-- <input formControlName="nationality" type="text" class="form-control" placeholder="Select Nationality"/> -->
                    <ng-select formControlName="nationality" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Nationality" type="text" 
                    [items]="countryListDropdown" bindLabel="name" bindValue="code">
                    </ng-select>
                  <div style="color:#ff3366" *ngIf="form.get('nationality')?.invalid && form.get('nationality')?.touched" class="error">
                    Please Select Nationality
                  </div>                       
                </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="dateOfBirth">Date of Birth<span aria-hidden="true"
                    class="symbol required"
                    style="color:red;">*</span></label>  
                  <!-- <input formControlName="dateOfBirth" type="text" class="form-control" placeholder="Select Date of Birth"/> -->
                  <input formControlName="dateOfBirth" ngbDatepicker [readonly]="!showFinalButton"  #dob="ngbDatepicker"  (click)="dob.toggle()"class="form-control" placeholder="Select Date of Birth"
                    [minDate]="{ year: 1900, month: 1, day: 1 }"  [maxDate]="maxDateFromDob" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                  <div style="color:#ff3366" *ngIf="form.get('dateOfBirth')?.invalid && form.get('dateOfBirth')?.touched" class="error">
                    Please Select Date of Birth
                  </div>
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="placeOfBirth">Place of Birth<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label> 
                    <ng-select formControlName="placeOfBirth" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Place of Birth" type="text" 
                    [items]="countryListDropdown" bindLabel="name" bindValue="code">
                    </ng-select>
                  <div style="color:#ff3366" *ngIf="form.get('placeOfBirth')?.invalid && form.get('placeOfBirth')?.touched" class="error">
                    Please Select Place of Birth
                  </div>                       
                </div>
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="address">Residential Address</label>  
                    <input formControlName="address" type="text" [readonly]="!showFinalButton" class="form-control" maxlength="400" placeholder="Enter Residential Address"/>                    
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="dualNationality">Dual Nationality</label>  
                    <!-- <input formControlName="dualNationality" type="text" class="form-control" placeholder="Select Dual Nationality"/>   -->
                    <ng-select formControlName="dualNationality" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" type="text" (change)="disabledDropdown($event,i)" placeholder="Select Dual Nationality">
                      <ng-option value="YES">Yes</ng-option>
                      <ng-option value="NO">No</ng-option>
                    </ng-select>                   
                </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="secondNationality">Nationality (Second)</label>  
                  <!-- <input formControlName="secondNationality" type="text" class="form-control" placeholder="Select Nationality (Second)"/> -->
                  <ng-select [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : form.value.nationalityColor" [readonly]="!showFinalButton" formControlName="secondNationality" placeholder="Select Nationality (Second)" type="text" 
                    [items]="countryListDropdown" bindLabel="name" bindValue="code">
                  </ng-select>
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="countryOfResidence">Residential Country<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label> 
                    <ng-select formControlName="countryOfResidence" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" (change)="changeResidenceCountry($event,i)" [readonly]="!showFinalButton" placeholder="Select Country of Residence" type="text" 
                    [items]="countryListDropdown" bindLabel="name" bindValue="code">
                    </ng-select>
                  <div style="color:#ff3366" *ngIf="form.get('countryOfResidence')?.invalid && form.get('countryOfResidence')?.touched" class="error">
                    Please Select Residential Country
                  </div>                       
                </div>
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="eid">Emirates ID Number</label>  
                    <input formControlName="eid" type="text" appEmiratesIdFormatter [readonly]="!showFinalButton" class="form-control" placeholder="Enter Emirates ID Number (XXX-XXXX-XXXXXXX-X)" maxlength="18"/>
                  <div style="color:#ff3366" *ngIf="form.get('eid')?.errors?.required && form.get('eid')?.touched" class="error">
                    Please Enter Emirates ID Number
                  </div> 
                  <div style="color:#ff3366" *ngIf="form.get('eid')?.errors?.pattern && form.get('eid')?.touched" class="error">
                    Please Enter Valid Emirates ID Number
                  </div> 
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="eidIssueDate">Emirates Issue Date</label>  
                    <input formControlName="eidIssueDate" ngbDatepicker [readonly]="!showFinalButton" #d="ngbDatepicker" class="form-control" placeholder="Select Emirates Issue Date"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"[maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate($event,i)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                  <div style="color:#ff3366;" *ngIf="form.get('eidIssueDate')?.errors?.required && form.get('eidIssueDate')?.touched" class="error">
                    Please Select Emirates Issue Date
                  </div>                       
                </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="eidExpiryDate">Emirates Expiry Date</label>  
                  <input formControlName="eidExpiryDate" class="form-control" [readonly]="!showFinalButton" ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="Select Emirates Expiry Date"
                        [minDate]="minDate"  [maxDate]="maxDateFromHundred" (ngModelChange)="changeEndDate($event)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()" />
                  <div style="color:#ff3366;" *ngIf="form.get('eidExpiryDate')?.errors?.required && form.get('eidExpiryDate')?.touched" class="error">
                    Please Select Emirates Expiry Date
                  </div>
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="passportIssueCountry">Passport Issue Country<span aria-hidden="true"
                    class="symbol required"
                    style="color:red;">*</span></label>  
                  <ng-select [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" formControlName="passportIssueCountry" placeholder="Select Passport Issue Country"
                    [items]="countryListDropdown" bindLabel="name" bindValue="code">
                  </ng-select>
                  <div style="color:#ff3366;" *ngIf="form.get('passportIssueCountry')?.invalid && form.get('passportIssueCountry')?.touched" class="error">
                    Please Select Passport Issue Country
                  </div>
                </div>
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="passportNumber">Passport Number<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="passportNumber" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter passport Number"/>
                  <div style="color:#ff3366" *ngIf="form.get('passportNumber')?.errors?.required && form.get('passportNumber')?.touched" class="error">
                    Please Enter Passport Number
                  </div> 
                  <div style="color:#ff3366" *ngIf="form.get('passportNumber')?.errors?.pattern && form.get('passportNumber')?.touched" class="error">
                    Please Enter Valid Passport Number
                  </div> 
                  <!-- <div style="color:#ff3366" *ngIf="form.get('idNumber')?.errors?.['pattern']  && form.get('idNumber')?.touched" class="error">
                    {{ getPatternErrorMessage(i) }}
                  </div>                                        -->
                </div>
                
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="passportIssueDate">Passport Issue Date<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="passportIssueDate" ngbDatepicker [readonly]="!showFinalButton" #p="ngbDatepicker" class="form-control" placeholder="Select Passport Issue Date"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"[maxDate]="maxDateFromPassport" (click)="p.toggle()" (ngModelChange)="changeDatePassportIssue($event,i)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                  <div style="color:#ff3366;" *ngIf="form.get('passportIssueDate')?.invalid && form.get('passportIssueDate')?.touched" class="error">
                    Please Select Passport Issue Date
                  </div>                       
                </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="passportExpiryDate">Passport Expiry Date<span aria-hidden="true"
                    class="symbol required"
                    style="color:red;">*</span></label>  
                  <!-- <input formControlName="idExpiryDate" type="text" class="form-control" placeholder="Enter Shareholder Percentage"/> -->
                  <input formControlName="passportExpiryDate" class="form-control" [readonly]="!showFinalButton" ngbDatepicker #p1="ngbDatepicker"  (click)="p1.toggle()" placeholder="Select Passport Expiry Date"
                        [minDate]="minDatePassport"  [maxDate]="maxDateFromHundred" (ngModelChange)="changeDatePassportExpiry($event)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()" />
                  <div style="color:#ff3366;" *ngIf="form.get('passportExpiryDate')?.invalid && form.get('passportExpiryDate')?.touched" class="error">
                    Please Select Passport Expiry Date
                  </div>
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6" >
                    <label class="col-form-label" for="mobileNumber">Mobile Number<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="mobileNumber" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter Mobile Number" maxlength="15" onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode  <= 57) || event.key === '+'"/>
                    <div style="color:#ff3366;" *ngIf="form.get('mobileNumber')?.errors?.required && form.get('mobileNumber')?.touched" class="error">
                      Please Enter Mobile Number
                    </div>
                    <div style="color:#ff3366;" *ngIf="form.get('mobileNumber')?.errors?.pattern && form.get('mobileNumber')?.touched" class="error">
                      Please Enter Valid Mobile Number
                    </div>
                  </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="emailId">Email ID<span aria-hidden="true"
                    class="symbol required"
                    style="color:red;">*</span></label>  
                  <input formControlName="emailId" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter Email ID"/>
                  <div style="color:#ff3366" *ngIf="form.get('emailId')?.errors?.required && form.get('emailId')?.touched" class="error">
                    Please Enter Email ID
                  </div> 
                  <div style="color:#ff3366;" *ngIf="form.get('emailId')?.errors?.pattern && form.get('emailId')?.touched" class="error">
                    Please enter Valid Email ID
                  </div>
                </div>
              </div>
              <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="pepFlag">PEP Flag</label>  
                    <!-- <input formControlName="pepFlag" type="text" class="form-control" placeholder="Enter PEP Flag"/>   -->
                    <ng-select formControlName="pepFlag" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" type="text" [readonly]="!showFinalButton" (change)="disabledPepDropdown($event,i)" placeholder="Enter PEP Flag">
                      <ng-option value="YES">Yes</ng-option>
                      <ng-option value="NO">No</ng-option>
                    </ng-select>                   
                </div> 
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="pepCategory">PEP Category</label>  
                  <input formControlName="pepCategory" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter PEP Category"/>
                </div>
              </div>
              <div class="row d-flex upload-wrapper">
                <div class="form-group col-md-12">
                    <label class="col-form-label" for="document">ID Upload<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                      <div class="file-preview" *ngFor="let document of form.value.documentList;">
                        <P>{{document.name}}</P>
                        <div class="file-actions">
                          <a (click)="downloadDocument(document.url,document.name)"><i class="feather icon-download icon-lg"></i></a>
                          <a *ngIf="permissions.includes('Approve')" (click)="deletedDocument(form.value.id,document.url)"><i class="feather icon-x icon-lg"></i></a>
                        </div>
                      </div>
                      <div class="file-preview" *ngIf="form.value.newFileName">
                        <!-- <P>New Document : </P> -->
                        <input type="text" [value]="form.value.newFileName" [title]="form.value.newFileName" disabled />
                        <div class="file-actions">
                          <a (click)="removeFile(i)"><i class="feather icon-x-circle icon-lg"></i></a>
                        </div>
                      </div>
                    <div class="upload-dropzone" (click)="fileInput.click()" *ngIf="permissions.includes('Add') && showFinalButton" (drop)="handleDrop($event,i)" (dragover)="allowDrop($event)">
                      Click or Drag Here to Upload
                      <input #fileInput type="file" multiple accept=".pdf,image/*" hidden (change)="onFileChange($event,i)" />
                    </div>
                  <div style="color:#ff3366;" *ngIf="form.get('document')?.hasError('required')" class="error">
                    Please Upload Document
                  </div>                       
                </div>
              </div>
              <div class="text-right">
                  <div class="form-group col-md-12">
                      <button *ngIf="permissions.includes('Add')" type="submit" class="btn btn-primary">Save</button>
                      <button *ngIf="!form.value.id && permissions.includes('Add')" (click)="removeForm(i)" type="button" class="btn btn-danger">Remove</button>
                      <button *ngIf="form.value.id && !showFinalButton && permissions.includes('Approve')" (click)="deleteOwner(form.value.id)" type="button" class="btn btn-danger">Delete</button>
                  </div>
              </div>
            </div>
            <div *ngIf="form.value.typeOfShareHolder === 'Entity'">
               <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="roleInEntity">Role in Entity<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <ng-select formControlName="roleInEntity" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Role in Entity" type="text" 
                      [items]="roleInEntityDropdown">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('roleInEntity')?.invalid && form.get('roleInEntity')?.touched" class="error">
                      Please Select Role in Entity
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="shareHolderName">Shareholder of</label>     
                      <input formControlName="shareHolderOf" [readonly]="true" type="text" class="form-control" />              
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="shareHolderName">Company Name<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <input formControlName="shareHolderName" [readonly]="!showFinalButton" type="text" class="form-control" placeholder="Enter Company Name"/>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderName')?.invalid && form.get('shareHolderName')?.touched" class="error">
                      Please Enter Company Name
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="companyType">Company Type<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <ng-select formControlName="companyType" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Company Type" type="text" 
                      [items]="companyTypeDropdown">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('companyType')?.invalid && form.get('companyType')?.touched" class="error">
                      Please Select Company Type
                    </div>                       
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="shareHolderPercentage">Shareholder % <span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="shareHolderPercentage" maxlength="5" [readonly]="!showFinalButton" type="text" class="form-control" placeholder="Enter Shareholder Percentage"  onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57) || (event.target.value.indexOf('.') < 0 && event.target.value.length>0 && event.charCode === 46)"/>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderPercentage')?.errors?.required && form.get('shareHolderPercentage')?.touched" class="error"> 
                      Please Enter Shareholder Percentage
                    </div>
                    <div style="color:#ff3366" *ngIf="form.get('shareHolderPercentage')?.errors?.max && form.get('shareHolderPercentage')?.touched" class="error">
                      Shareholder Percentage must be below or equal to 100
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="col-form-label" for="natureOfBusiness">Nature of Business<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label> 
                    <input formControlName="natureOfBusiness" type="text" [readonly]="!showFinalButton" class="form-control" maxlength="400" placeholder="Enter Nature of Business"/>                    
                    <div style="color:#ff3366" *ngIf="form.get('natureOfBusiness')?.invalid && form.get('natureOfBusiness')?.touched" class="error">
                      Please Enter Nature of Business
                    </div>                       
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="registrationNumber">Registration Number</label>  
                      <input formControlName="registrationNumber" type="text" [readonly]="!showFinalButton" class="form-control" placeholder="Enter Registration Number"/>
                  </div>
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="address">Registered Address</label>  
                      <input formControlName="address" type="text" [readonly]="!showFinalButton" class="form-control" maxlength="400" placeholder="Enter Residential Address"/>                    
                  </div>
                </div>
                 <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="countryOfIncorporation">Jurisdiction / Country of Incorporation</label>  
                      <ng-select formControlName="countryOfIncorporation" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" placeholder="Select Jurisdiction / Country of Incorporation" type="text" 
                      [items]="countryListDropdown" bindLabel="name" bindValue="code">
                      </ng-select>                    
                  </div>
                  <div class="form-group col-md-6" >
                    <label class="col-form-label" for="dateOfIncorporation">Date of Incorporation</label>  
                    <input formControlName="dateOfIncorporation" ngbDatepicker [readonly]="!showFinalButton"  #dob="ngbDatepicker"  (click)="dob.toggle()"class="form-control" placeholder="Select Date of Incorporation"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"  [maxDate]="maxDateFromDob" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                  </div>
                </div>
                <div class="row d-flex">
                  <div class="form-group col-md-6">
                      <label class="col-form-label" for="idType">ID Type<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                      <ng-select formControlName="idType" [style]="!showFinalButton ? { 'background-color': '#e9ecef' } : {}" [readonly]="!showFinalButton" (change)="idTypeChange($event,i)" placeholder="Select ID Type" type="text" 
                      [items]="idTypeDropdown">
                      </ng-select>
                    <div style="color:#ff3366" *ngIf="form.get('idType')?.invalid && form.get('idType')?.touched" class="error">
                      Please Select ID Type
                    </div>                       
                  </div>
                  <div class="form-group col-md-6">
                    <label class="col-form-label" for="idNumber">Identification Document Number<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label> 
                    <input formControlName="idNumber" type="text" [readonly]="!showFinalButton" class="form-control" maxlength="400" placeholder="Enter Identification Document Number"/>                    
                    <div style="color:#ff3366" *ngIf="form.get('idNumber')?.invalid && form.get('idNumber')?.touched" class="error">
                      Please Enter Identification Document Number
                    </div>                       
                  </div>
                </div>
                <div class="row d-flex">
                <div class="form-group col-md-6">
                    <label class="col-form-label" for="idIssueDate">ID Issue Date<span aria-hidden="true"
                      class="symbol required"
                      style="color:red;">*</span></label>  
                    <input formControlName="idIssueDate" ngbDatepicker [readonly]="!showFinalButton" #d="ngbDatepicker" class="form-control" placeholder="Select ID Issue Date"
                      [minDate]="{ year: 1900, month: 1, day: 1 }"[maxDate]="maxDateFrom" (click)="d.toggle()" (ngModelChange)="changeDate($event,i)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()"/>
                  <div style="color:#ff3366;" *ngIf="form.get('idIssueDate')?.invalid && form.get('idIssueDate')?.touched" class="error">
                    Please Select ID Issue Date
                  </div>                       
                </div>
                <div class="form-group col-md-6" >
                  <label class="col-form-label" for="idExpiryDate">ID Expiry Date</label>  
                  <input formControlName="idExpiryDate" class="form-control" [readonly]="!showFinalButton" ngbDatepicker #d1="ngbDatepicker"  (click)="d1.toggle()" placeholder="Select ID Expiry Date"
                        [minDate]="minDate"  [maxDate]="maxDateFromHundred" (ngModelChange)="changeEndDate($event)" (paste)="$event.preventDefault()" (keydown)="$event.preventDefault()" />
                  <div style="color:#ff3366;" *ngIf="form.get('idExpiryDate')?.errors?.required && form.get('idExpiryDate')?.touched" class="error">
                    Please Select ID Expiry Date
                  </div>
                </div>
              </div>
                <div class="row d-flex upload-wrapper">
                  <div class="form-group col-md-12">
                      <label class="col-form-label" for="document">ID Upload<span aria-hidden="true"
                        class="symbol required"
                        style="color:red;">*</span></label>  
                        <div class="file-preview" *ngFor="let document of form.value.documentList;">
                          <P>{{document.name}}</P>
                          <div class="file-actions">
                            <a (click)="downloadDocument(document.url,document.name)"><i class="feather icon-download icon-lg"></i></a>
                            <a *ngIf="permissions.includes('Approve')" (click)="deletedDocument(form.value.id,document.url)"><i class="feather icon-x icon-lg"></i></a>
                          </div>
                        </div>
                        <div class="file-preview" *ngIf="form.value.newFileName">
                          <!-- <P>New Document : </P> -->
                          <input type="text" [value]="form.value.newFileName" [title]="form.value.newFileName" disabled />
                          <div class="file-actions">
                            <a (click)="removeFile(i)"><i class="feather icon-x-circle icon-lg"></i></a>
                          </div>
                        </div>
                      <div class="upload-dropzone" (click)="fileInput.click()" *ngIf="permissions.includes('Add') && showFinalButton" (drop)="handleDrop($event,i)" (dragover)="allowDrop($event)">
                        Click or Drag Here to Upload
                        <input #fileInput type="file" multiple accept=".pdf,image/*" hidden (change)="onFileChange($event,i)" />
                      </div>
                    <div style="color:#ff3366;" *ngIf="form.get('document')?.hasError('required')" class="error">
                      Please Upload Document
                    </div>                       
                  </div>
                </div>
                <div class="text-right">
                    <div class="form-group col-md-12">
                       <button *ngIf="permissions.includes('Add') && form.value.id  && !(form.value.entityTotalPercentage >= 100)" type="button" (click)="addChildUBO(i)" class="btn btn-primary">Add</button>
                        <button *ngIf="permissions.includes('Add')" type="submit" class="btn btn-primary">Save</button>
                        <button *ngIf="!form.value.id && permissions.includes('Add')" (click)="removeForm(i)" type="button" class="btn btn-danger">Remove</button>
                        <button *ngIf="form.value.id && !showFinalButton && permissions.includes('Approve')" (click)="deleteOwner(form.value.id)" type="button" class="btn btn-danger">Delete</button>
                    </div>
                </div>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
      </fieldset>
      </form>
    </div>
    <div class="mb-2 text-center" *ngIf="permissions.includes('Add')">
      <!-- <button *ngIf="enableAddButton && showFinalButton" (click)="addForm()" type="button" class="btn btn-primary">Add</button> -->
       <!-- <button *ngIf="enableAddButton && showFinalButton && !(totalPercentage >= 100) && !hasPOA" (click)="openType()" type="button" class="btn btn-primary">Add</button> -->
       <button
        *ngIf="enableAddButton && showFinalButton && (totalPercentage < 100 || (totalPercentage >= 100 && !hasPOA))"
        (click)="openType()"
        type="button"
        class="btn btn-primary">
        Add
      </button>


       <!-- <button *ngIf="enableAddButton && showFinalButton" (click)="openType()" type="button" class="btn btn-primary">Add</button> -->
      <button *ngIf="showFinalButton && UBOList.length != 0" (click)="submitAllUBO()" type="button" class="btn btn-success">Submit</button>
      <hr>
    </div>
    
    

    <!-- -----------------------------UBO ENDING------------------------------- -->
    <div class="card-body row border-danger" *ngIf="merchantKycDetails?.length > 0 && permissions.includes('Approve')">
<!--      {{ this.isApprovalEnable}}-->
      <form [formGroup]="kycApprovalForm">
        <div class="row">
          <div class="col-6">
            <label class="form-label"><b>Remarks</b></label>
            <input type="text" placeholder="Please add remarks" class="form-control"
                   [ngClass]="{'is-invalid': kycApprovalForm.get('remarks')?.errors?.required}"
                   formControlName="remarks" id="remarks"/>
          </div>
          <div *ngIf="kycApprovalForm.get('remarks')?.errors" class="invalid-feedback">
            Remarks is required
          </div>
        </div>
        <div class="row mt-2" *ngIf="permissions.includes('Approve')">
          <div class="col-xs-12">
            <div class="text-center">
              <button class="btn btn-secondary" [disabled]="(!this.isApprovalEnable)" (click)="statusApproval(1)"><i
                class="feather icon-thumbs-up"></i>Approve
              </button>
              <button class="btn btn-primary" [disabled]="(!this.isApprovalEnable)" (click)="statusApproval(2)">Reject <i
                class="feather icon-thumbs-down"></i>
              </button>
            </div>
          </div>
        </div>
      </form>

    </div>
  </div>

  <div class="row" style="min-height: 300px">
    <div class="col-12 col-xl-12 stretch-card ag-theme-alpine">
      <ag-grid-angular  (gridReady)="onGridReady($event)"
                       [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
                       [paginationPageSize]="pageSize" [pagination]="true" [rowData]="remarkData"
                       [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
                       style="width: 100%; height: auto;"></ag-grid-angular>
    </div>
</div>
<!--Main Upload Section-->

<!--Upload Doc List-->
<app-modal #kycUploadModal [modalConfig]="kycUploadModalConfig">
  <app-kyc-doc-list [merchantId]="merchantId" [globalDisableFlag]="globalDisableFlag" [localDisableFlag]="localDisableFlag" [selectedKycData]="currentSelectedGroup"></app-kyc-doc-list>
</app-modal>
<!---->
<!--Upload Doc List-->
<app-modal #kycFileViewModal [modalConfig]="kycViewModalConfig">
  <iframe width="100%" height="100%" *ngIf="kycFileSrc?.type === 'FILE'" [src]="kycFileSrc.src"></iframe>
  <img width="100%" *ngIf="kycFileSrc?.type === 'IMAGE'" [src]="kycFileSrc.src" alt="Image">
  <div *ngIf="!kycFileSrc">
    <p>Could not view the file</p>
  </div>
</app-modal>
<!---->

